import { createDefaultNativeStackNavigator } from 'app/lib/navigation';
import type { PopularItem } from 'app/types/category';
import { ContactInformationScreen } from 'app/screens/onboarding/contact-information';
import { CredentialsScreen } from 'app/screens/onboarding/credentials';
import { PersonalInformationScreen } from 'app/screens/onboarding/personal-information';
import { ChooseSharerTypeScreen } from './choose-sharer-type';
import { ChooseWebScreen } from './choose.web';
import { ConfirmWebScreen } from './confirm.web';
import { GuidelinesScreen } from './guidelines';
import { ThanksWebScreen } from './thanks.web';

export type Parameters = {
  credentials:
    | {
        inviteCode?: string;
        inviteCodeFirst?: boolean;
        userType?: string;
        hideCross?: boolean;
      }
    | undefined;
  // 'email-verification': { email: string; password: string };
  'personal-information': { hideCross?: boolean } | undefined;
  'contact-information':
    | {
        email?: string;
        hideCross?: boolean;
        userType?: string;
      }
    | undefined;
  'choose-sharer-type': { hideCross?: boolean } | undefined;
  guidelines: { hideCross?: boolean } | undefined;

  // Specific to web platform before naviate to billboard
  choose: undefined;
  confirm: { selectedItems: PopularItem[] };
  thanks: { userNowContributor: boolean; listingIds?: string[] };
};

export { linking } from './navigator.linking';

const Stack = createDefaultNativeStackNavigator<Parameters>({
  withChat: false,
  withInvite: false,
});

export function Navigator() {
  return (
    <Stack.Navigator initialRouteName="contact-information">
      <Stack.Screen component={ContactInformationScreen} name="contact-information" />
      <Stack.Screen component={CredentialsScreen} name="credentials" />
      <Stack.Screen component={PersonalInformationScreen} name="personal-information" />
      <Stack.Screen component={ChooseSharerTypeScreen} name="choose-sharer-type" />
      <Stack.Screen component={GuidelinesScreen} name="guidelines" />
      <Stack.Screen component={ChooseWebScreen} name="choose" />
      <Stack.Screen component={ConfirmWebScreen} name="confirm" />
      <Stack.Screen component={ThanksWebScreen} name="thanks" />
    </Stack.Navigator>
  );
}
